export default __webpack_public_path__ + "static/media/MediumIcon.21b4c748.svg";